module.exports = __webpack_public_path__ + "img/ifo_logo.763e4df8.png";